import { render, staticRenderFns } from "./form_historic_assignment_component.vue?vue&type=template&id=ec1cef7a&scoped=true"
import script from "./form_historic_assignment_component.vue?vue&type=script&lang=js"
export * from "./form_historic_assignment_component.vue?vue&type=script&lang=js"
import style0 from "./form_historic_assignment_component.vue?vue&type=style&index=0&id=ec1cef7a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1cef7a",
  null
  
)

export default component.exports